import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  changeTheme(className = 'avs-dark') {
    document.body.classList.add(className);
  }
}

(window as any).theme = new ThemeService();
